import React, { Component, createRef } from "react";
import ReactDataSheet from "react-datasheet";
import { ReactComponent as Plus } from "./plus.svg";
import { ReactComponent as Minus } from "./minus.svg";
import { ReactComponent as Save } from "./save.svg";
import { ReactComponent as Calc } from "./calc.svg";
import { ReactComponent as Export } from "./export.svg";
import { ReactComponent as CSV } from "./csv.svg";
import { ReactComponent as Excel } from "./excel.svg";
import { transliterate, splitFullName } from "./transliterate";
import { utils, writeFile } from "xlsx";
import { unparse } from "papaparse";



const now = new Date();

const day = String(now.getDate()).padStart(2, '0');
const month = String(now.getMonth() + 1).padStart(2, '0');
const year = String(now.getFullYear()).slice(-2);

const formatted = `${day}-${month}-${year}`;




class Grid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      grid: [
        [
          { readOnly: true, value: "#", className: "row-index" },
          { value: "FIO", className: "row-header fio-heder" },
          { value: "username", className: "row-header" },
          { value: "lastname", className: "row-header" },
          { value: "firstname", className: "row-header" },
          { value: "password", className: "row-header" },
          { value: "email", className: "row-header" },
          { value: "group1", className: "row-header" },
          { value: "course1", className: "row-header" },
        ],

        [
          { readOnly: true, value: 1, className: "row-index" },
          { value: "Иванов Иван Иванович" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 2, className: "row-index" },
          { value: "Петров Петр Перович" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 3, className: "row-index" },
          { value: "Сидоров Сидр Сидорович" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 4, className: "row-index" },
          { value: "Пушкина Татьяна Васильевна" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 5, className: "row-index" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 6, className: "row-index" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 7, className: "row-index" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 8, className: "row-index" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 9, className: "row-index" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
        [
          { readOnly: true, value: 10, className: "row-index" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ],
      ],
      selected: [],
      forceRerender: false, // Флаг для принудительного ререндера
      isRandomPass: false,
      mailserver: "@ama.spbgau.ru",
      //group: "GROUP-NAME",
      group: formatted,
      kursname: "KURS-NAME",
    };
    this.sheetRef = createRef();
  }

  handleClickOutside = (event) => {
    if (
      this.sheetRef.current &&
      !this.sheetRef.current.contains(event.target)
    ) {
      this.setState((prevState) => ({
        forceRerender: !prevState.forceRerender, // Триггер ререндеринга
      }));
    }
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleSelect = (selected) => {
    this.setState({ selected });
  };

  render() {
    return (
      <div className="main-comtainer">
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
          <div className="container-fluid">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavAltMarkup"
              aria-controls="navbarNavAltMarkup"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
              <div className="navbar-nav panel">
                <p className="nav-link">Rows</p>
                <a className="nav-link">
                  <button className="panel-btn" onClick={this.addRows}>
                    <Plus />
                  </button>
                </a>
                <a className="nav-link">
                  <button
                    className="panel-btn"
                    onClick={this.removeSelectedRows}
                  >
                    <Minus />
                  </button>
                </a>
                <p className="panel-divider">|</p>
                <p className="nav-link">Cols</p>
                <a className="nav-link" onClick={this.addColumn}>
                  <button className="panel-btn">
                    <Plus />
                  </button>
                </a>
                <a className="nav-link" onClick={this.removeColumn}>
                  <button className="panel-btn">
                    <Minus />
                  </button>
                </a>
                <p className="panel-divider">|</p>
                <a className="nav-link">
                  <button className="panel-btn" onClick={this.CalcData}>
                    <Calc />
                  </button>
                </a>

                <p className="panel-divider">|</p>
                <div className="pass-check flex items-center space-x-2 p-2">
                  <input
                    type="checkbox"
                    id="checkbox"
                    defaultChecked={this.state.isRandomPass}
                    onChange={this.handlePassChange}
                    className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  />
                  <label
                    htmlFor="checkbox"
                    className="text-lg font-medium px-2"
                  >
                    Random Pass
                  </label>
                </div>

                <p className="panel-divider">|</p>
                <div className="pass-check flex items-center space-x-2 p-0">
                  <input
                    type="text"
                    name="mailserver"
                    value={this.state.mailserver}
                    onChange={this.onChangeText}
                    className="w-60 p-2 border border-gray-300 rounded focus:ring-blue-500"
                    placeholder="@mail.ru"
                  />
                </div>

                <p className="panel-divider">|</p>
                <div className="pass-check flex items-center space-x-2 p-0">
                  <input
                    type="text"
                    name="group"
                    value={this.state.group}
                    onChange={this.onChangeText}
                    className="w-60 p-2 border border-gray-300 rounded focus:ring-blue-500"
                    placeholder="GROUP1"
                  />
                </div>

                <p className="panel-divider">|</p>
                <div className="pass-check flex items-center space-x-2 p-0">
                  <input
                    name="kursname"
                    type="text"
                    value={this.state.kursname}
                    onChange={this.onChangeText}
                    className="w-60 p-2 border border-gray-300 rounded focus:ring-blue-500"
                    placeholder="KURS-NAME"
                  />
                </div>

                <p className="panel-divider">|</p>
                <a className="nav-link" onClick={this.saveToFile}>
                  <button className="panel-btn panel-btn-w-text">
                    <Export />
                    JSON Save
                  </button>
                </a>

                <p className="panel-divider">|</p>

                <p>
                  <label htmlFor="file-input" className="custom-file-upload">
                    <Export /> JSON Load
                  </label>
                  <input
                    type="file"
                    accept=".json"
                    id="file-input"
                    onChange={this.loadFromFile}
                  ></input>
                </p>
                <p className="panel-divider">|</p>
                <a className="nav-link" onClick={this.exportToCSV}>
                  <button className="panel-btn panel-btn-w-text">
                    <CSV />
                    CSV Export
                  </button>
                </a>
                <p className="panel-divider">|</p>
                <a className="nav-link" onClick={this.exportToExcel}>
                  <button className="panel-btn panel-btn-w-text">
                    <Excel />
                    Excel Export
                  </button>
                </a>
              </div>
            </div>
          </div>
        </nav>
        <ReactDataSheet
          overflow={"nowrap"}
          key={this.state.forceRerender} // Изменение key принудительно рендерит компонент
          selected={this.state.selected}
          onSelect={this.handleSelect}
          data={this.state.grid}
          valueRenderer={(cell) => cell.value}
          onCellsChanged={(changes) => {
            const grid = this.state.grid.map((row) => [...row]);
            changes.forEach(({ cell, row, col, value }) => {
              grid[row][col] = { ...grid[row][col], value };
            });
            this.setState({ grid });
          }}
        />
        {/* {JSON.stringify(this.state)} */}
      </div>
    );
  }

  removeColumn = () => {
    this.setState((prevState) => {
      const newData = prevState.grid.map((row) => row.slice(0, -1)); // Убираем последний элемент в каждой строке

      return { grid: newData };
    });
  };

  addColumn = () => {
    this.setState((prevState) => {
      const newData = prevState.grid.map((row) => [...row, { value: "" }]); // Добавляем новый пустой столбец в каждую строку

      return { grid: newData };
    });
  };

  exportToCSV = () => {
    const { grid } = this.state; // Данные из react-datasheet

    if (!Array.isArray(grid) || grid.length === 0) {
      console.error("Grid is empty or not an array");
      return;
    }

    // Преобразуем в массив значений, пропуская первые две колонки
    const csvData = grid.map((row) =>
      row
        .slice(2)
        .map((cell) =>
          cell && typeof cell.value !== "undefined" ? cell.value : "",
        ),
    );

    // Преобразуем в CSV-формат
    const csv = unparse(csvData, { delimiter: ";" });

    const now = new Date();
    const dateString = now
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, "")
      .replace(/T/g, "-")
      .replace(/:/g, "-");

    // Создаем файл и даем пользователю скачать
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = this.state.kursname + "-" + dateString + ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  exportToExcel = () => {
    const { grid } = this.state; // Ваши данные из react-datasheet

    if (!Array.isArray(grid) || grid.length === 0) {
      console.error("Grid is empty or not an array");
      return;
    }

    // Преобразуем данные в массив значений (таблицу)
    const sheetData = grid.map((row) =>
      row.map((cell) =>
        cell && typeof cell.value !== "undefined" ? cell.value : "",
      ),
    );

    const now = new Date();
    const dateString = now
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, "")
      .replace(/T/g, "-")
      .replace(/:/g, "-");

    // Создаем рабочий лист и книгу
    const ws = utils.aoa_to_sheet(sheetData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    // Сохраняем файл Excel
    try {
      writeFile(wb, this.state.kursname + "-" + dateString + ".xlsx");
    } catch (error) {
      console.error("Error writing file:", error);
    }
  };

  // Функция сохранения состояния в файл
  saveToFile = () => {
    const json = JSON.stringify(this.state, null, 2);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    const now = new Date();
    const dateString = now
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, "")
      .replace(/T/g, "-")
      .replace(/:/g, "-");

    const a = document.createElement("a");
    a.href = url;
    a.download = this.state.kursname + "-" + dateString + ".json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // Функция загрузки состояния из файла
  loadFromFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const loadedData = JSON.parse(e.target.result);

        this.setState(loadedData);
      } catch (error) {
        console.error("Ошибка загрузки файла:", error);
      }
    };
    reader.readAsText(file);
  };

  onChangeText = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handlePassChange = (event) => {
    this.setState((prevState) => {
      return { isRandomPass: event.target.checked };
    });
  };

  CalcData = () => {
    this.setState((prevState) => {
      const fio = 1;
      const username = 2;
      const lastname = 3;
      const firstname = 4;
      const password = 5;
      const email = 6;
      const group = 7;
      const kurs = 8;

      const rowCount = prevState.grid.length; // Количество строк

      for (let index = 1; index < rowCount; index++) {
        const element = prevState.grid[index];

        const curfio = element[fio].value.trim();
        if (curfio) {
          const lccurfio = curfio.toLowerCase();
          const trlccurfio = transliterate(lccurfio);
          const unname = trlccurfio.replaceAll("`", "").replaceAll(" ", ".");
          const objName = splitFullName(curfio);
          //set username
          prevState.grid[index][username].value = unname;
          prevState.grid[index][lastname].value = objName.lastName;
          prevState.grid[index][firstname].value = objName.firstMiddleName;

          if (prevState.isRandomPass) {
            const randomString = Math.random().toString().slice(2, 10);
            prevState.grid[index][password].value = randomString;
          } else {
            prevState.grid[index][password].value = "12345";
          }

          prevState.grid[index][email].value = unname + this.state.mailserver;
          prevState.grid[index][group].value = prevState.group;
          prevState.grid[index][kurs].value = prevState.kursname;
        }
      }

      return { grid: prevState.grid };
    });
  };

  addRow = () => {
    this.setState((prevState) => {
      const rowCount = prevState.grid.length; // Количество строк
      const colCount = prevState.grid[0]?.length || 1; // Количество колонок (если нет данных, минимум 1)

      // Создаем новую строку: первая колонка = номер строки, остальные пустые
      const newRow = Array.from({ length: colCount }, (_, colIndex) =>
        colIndex === 0
          ? {
              readOnly: true,
              className: "row-index",
              value: rowCount.toString(),
            }
          : { value: "" },
      );

      return { grid: [...prevState.grid, newRow] };
    });
  };

  addRows = () => {
    this.setState((prevState) => {
      const rowCount = prevState.grid.length; // текущее количество строк
      const colCount = prevState.grid[0]?.length || 1; // количество колонок

      // создаём сразу 10 новых строк
      const newRows = Array.from({ length: 10 }, (_, rowOffset) => {
        const rowIndex = rowCount + rowOffset; // индекс для первой колонки
        return Array.from({ length: colCount }, (_, colIndex) =>
          colIndex === 0
            ? {
                readOnly: true,
                className: "row-index",
                value: rowIndex.toString(),
              }
            : { value: "" },
        );
      });

      return { grid: [...prevState.grid, ...newRows] };
    });
  };

  removeSelectedRows = () => {
    this.setState((prevState) => {
      if (!prevState.selected) return prevState; // Если ничего не выделено — не удаляем

      const { start, end } = prevState.selected;
      const startRow = Math.min(start.i, end.i);
      const endRow = Math.max(start.i, end.i);

      // Фильтруем только те строки, которые НЕ находятся в диапазоне startRow → endRow
      const newGrid = prevState.grid.filter(
        (_, rowIndex) =>
          rowIndex === 0 || rowIndex < startRow || rowIndex > endRow,
      );

      // Перенумеровываем оставшиеся строки, кроме первой (заголовка)
      newGrid.forEach((row, index) => {
        if (index > 0 && row[0]) row[0].value = index.toString();
      });

      return { grid: newGrid, selected: null }; // Очищаем выделение после удаления
    });
  };

  OnSelectRows = (selected) => {
    // console.log(start,end);

    this.setState({
      selected: selected,
    });
  };
}

export default Grid;
